import React, { useEffect } from "react";

const clients = [
  { id: 2, logo: "/assets/png/logo/Fit4 life-02.png" },
  { id: 3, logo: "/assets/png/logo/Fit4 life-03.png" },
  { id: 4, logo: "/assets/png/logo/Fit4 life-04.png" },
  { id: 5, logo: "/assets/png/logo/Fit4 life-05.png" },
  { id: 6, logo: "/assets/png/logo/Fit4 life-06.png" },
  { id: 7, logo: "/assets/png/logo/Fit4 life-07.png" },
  { id: 10, logo: "/assets/png/logo/Fit4 life-10.png" },
  { id: 13, logo: "/assets/png/logo/Fit4 life-13.png" },
  { id: 14, logo: "/assets/png/logo/Fit4 life-14.png" },
  { id: 16, logo: "/assets/png/logo/Fit4 life-16.png" },
  { id: 17, logo: "/assets/png/logo/Fit4 life-17.png" },
  { id: 19, logo: "/assets/png/logo/Fit4 life-19.png" },
  { id: 20, logo: "/Logo/Agri Inverse.png" },
  { id: 21, logo: "/Logo/EmailerX Logo.png" },
  { id: 22, logo: "/Logo/Eye Shore.png" },
  { id: 23, logo: "/Logo/Farma Heritage Logo.png" },
  { id: 24, logo: "/Logo/Feminine System.png" },
  { id: 25, logo: "/Logo/Fincliniq.png" },
  { id: 26, logo: "/Logo/GMBC Logo.png" },
  { id: 27, logo: "/Logo/Inboxist Logo.png" },
  { id: 28, logo: "/Logo/Mind and company.png" },
  { id: 29, logo: "/Logo/Newzealand Gateway.png" },
  { id: 30, logo: "/Logo/Phytonutics.png" },
  { id: 32, logo: "/Logo/ZoflowX.png" },
  { id: 33, logo: "/Logo/Vdhya.png" },
  { id: 34, logo: "/Logo/AMZ.png" },
  { id: 35, logo: "/Logo/boxsy.png" },
  { id: 36, logo: "/Logo/Click Up.png" },
  { id: 37, logo: "/Logo/Enclaim.png" },
  { id: 38, logo: "/Logo/Enzymco.png" },
  { id: 39, logo: "/Logo/Fcoas.png" },
  { id: 40, logo: "/Logo/Gichaak.png" },
  { id: 41, logo: "/Logo/Gratus Natural.png" },
  { id: 42, logo: "/Logo/Harissh Dental Hub.png" },
  { id: 43, logo: "/Logo/Jornie.png" },
  { id: 44, logo: "/Logo/Jovis Kitchen.png" },
  { id: 45, logo: "/Logo/kalam foundation.png" },
  { id: 46, logo: "/Logo/Pytonautics.png" },
  { id: 47, logo: "/Logo/Srishti.png" },
  { id: 48, logo: "/Logo/TheCA Classroom.png" },
  { id: 49, logo: "/Logo/Venster.png" },
  { id: 50, logo: "/Logo/Vyon.png" },
];

const LogoCarousel = () => {
  useEffect(() => {
    // Clone the logos-slide element for infinite scrolling
    const logoSlide = document.querySelector(".logos-slide");

    if (logoSlide) {
      // Clone the slide
      const copy = logoSlide.cloneNode(true);

      // Append the cloned node immediately after the original one
      const parentElement = logoSlide.parentElement;

      // Ensure the parent uses flexbox and aligns items in a row
      parentElement.style.display = "flex"; // Ensure flex layout
      parentElement.style.alignItems = "center"; // Ensure align center
      parentElement.style.flexWrap = "nowrap"; // Prevent wrapping
      parentElement.style.overflow = "hidden"; // Prevent overflow

      // Set the original slide's styles to ensure proper alignment
      logoSlide.style.flexShrink = "0"; // Prevent wrapping
      logoSlide.style.whiteSpace = "nowrap";

      // Adjust cloned node styles
      copy.style.flexShrink = "0"; // Prevent wrapping
      copy.style.whiteSpace = "nowrap";
      copy.style.margin = "1px";
      copy.style.padding = "20px 10px";

      // Add a margin or gap to ensure no overlap
      copy.style.marginLeft = "0px";

      parentElement.appendChild(copy);
    }
  }, []);

  return (
    <div
      className="relative py-8"
      style={{
        backgroundImage: "url('/assets/svg/plain_dot.svg')",
      }}
    >
      <img
        src="/assets/png/Ellipse_left.png"
        alt="gradient"
        className="absolute bottom-0 left-0"
      />
      <img
        src="/assets/png/Ellipse_right.png"
        alt="gradient"
        className="absolute top-0 right-0"
      />
      {/* Heading Section */}
      <div className="flex items-center justify-center flex-col text-center ">
        <h2 className="text-2xl md:text-3xl font-semibold text-[#1E1A1C] font-inter leading-tight">
          Trusted By 500+ Brands
        </h2>
      </div>

      {/* Logo Slider */}
      <div className="logos overflow-hidden pb-8 relative">
        <div className="logos-slide flex whitespace-nowrap animate-slide hover:pause-animation cursor-pointer">
          {clients.map((client) => (
            <div key={client.id} className="shadow py-4 px-2.5 m-2 border-2 rounded-[10px]">
              <img
                src={client.logo}
                alt={`Client ${client.id}`}
                className="h-16 mx-10"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LogoCarousel;
